//菜单收藏操作
import {QueryCommand} from "xmgoing-server";
import {StorageUtils} from 'xmgoing-utils';

/**
 * 侧栏叶子选中身份：必须用唯一菜单 id（同页多入口共享 appOldId，不能当 key）
 */
export function getMenuEntryKey(item) {
  if (!item) return '';
  if (item.id != null && item.id !== '') return String(item.id);
  if (item.path != null && item.path !== '') return String(item.path);
  return '';
}

function matchesEntryId(item, key) {
  if (!item || key == null || key === '') return false;
  return item.id != null && String(item.id) === String(key);
}

/**
 * 按菜单入口 id 或页面路径查找。path 多入口时优先 session curMenuEntryId。
 */
export const getMenuObjByKey = function (menuList, key, targetObj) {
  if (!menuList || key == null || key === '') return;
  const k = String(key);
  const prefer = StorageUtils.getSessionItem('curMenuEntryId');
  const pathMatches = [];

  const walk = (list) => {
    if (!list) return false;
    for (const itemObj of list) {
      if (!itemObj) continue;
      // 只按唯一 id 精确命中，禁止用 appOldId（多入口会撞车）
      if (matchesEntryId(itemObj, k)) {
        targetObj.target = itemObj;
        return true;
      }
      if (itemObj.path != null && String(itemObj.path) === k) {
        pathMatches.push(itemObj);
      }
      if (itemObj.children && walk(itemObj.children)) return true;
      if (itemObj.subMenus && walk(itemObj.subMenus)) return true;
    }
    return false;
  };

  if (walk(menuList)) return;

  if (pathMatches.length > 0) {
    if (prefer != null && prefer !== '') {
      const preferred = pathMatches.find((item) => matchesEntryId(item, prefer));
      if (preferred) {
        targetObj.target = preferred;
        return;
      }
    }
    targetObj.target = pathMatches[0];
  }
}

/**
 * 埋点工具类
 */
export const PointUtils = {
  //菜单埋点操作
  addMenuPoint({key, menuList}) {
    const targetObj: any = {};
    if (menuList && Array.isArray(menuList)) {
      setTimeout(() => {
        getMenuObjByKey(menuList, key, targetObj);
        if (targetObj.target) {
          const queryCommand = new QueryCommand({
            errorFlag:false,
            sysErrorFlag:false,
            url: '/api/pe-portal/dataCount/useMenu',
            showTip: false,
          });
          queryCommand.executeQueryPromise({params: {dataId: targetObj.target.id}}).then(() => {
          })
        }
      }, 800);
    }
  }
}
